export const LOGIN = '/access/login/';
export const LOGOUT = '/access/logout/';
